import { ApiUpdateBonusCreationResponseType } from 'src/api_openapi/v2/bonus-engine/apiUpdateBonusCreation';
import { ApiUpdateCampaignResponseType } from 'src/api_openapi/v2/bonus-engine/apiUpdateCampaign';
import { ParamsTypeZOD } from 'src/api_openapi/v2/bonus-engine/apiCreateBonusCreation';
import { z } from 'zod';

type ApiUpdateEntityResponseErrorType = {
    status: 400 | 401 | 403 | 404 | 422 | 500;
    body: {
        message: string;
    };
};

export type BonusCreationFormType = z.TypeOf<typeof ParamsTypeZOD.shape.requestBody>;
export const BonusCreationFormZodType = ParamsTypeZOD.shape.requestBody;

export const isError = (source: unknown): source is Error => {
    return source instanceof Error;
};

export const isApiUpdateBonusCreationResponseType = (source: unknown): source is ApiUpdateBonusCreationResponseType => {
    return typeof source === 'object' && source !== null && 'status' in source && 'body' in source;
};

export const isInvalidUpdateBonusCreationRes = (source: unknown): source is ApiUpdateEntityResponseErrorType => {
    return isApiUpdateBonusCreationResponseType(source) && 'message' in source.body;
};

export const isApiUpdateCampaignResponseType = (source: unknown): source is ApiUpdateCampaignResponseType => {
    return typeof source === 'object' && source !== null && 'status' in source && 'body' in source;
};

export const isInvalidUpdateCampaignRes = (source: unknown): source is ApiUpdateEntityResponseErrorType => {
    return isApiUpdateCampaignResponseType(source) && 'message' in source.body;
};
